import { useId } from 'react';
import { Dialog } from '@headlessui/react';
import { VacationDpDecisionPanel } from './VacationDpDecisionPanel';
import type { VacationDpDecisionModalProps } from './vacationDpDecisionModal.types';

export function VacationDpDecisionModal({
    isOpen,
    row,
    onClose,
    onConfirm,
    isSubmitting = false,
    allRows = [],
    isOwnRequest = false,
}: VacationDpDecisionModalProps) {
    const titleId = useId();
    const request = row?.request ?? null;

    if (!isOpen || !row || !request) return null;

    return (
        <Dialog open={isOpen} onClose={onClose} className="relative z-50" aria-labelledby={titleId}>
            <div className="fixed inset-0 bg-black/30" aria-hidden="true" />

            <div className="fixed inset-0 flex items-center justify-center p-4">
                <Dialog.Panel className="flex max-h-[90vh] w-full max-w-4xl flex-col overflow-hidden rounded-2xl bg-white shadow-xl">
                    <VacationDpDecisionPanel
                        row={row}
                        request={request}
                        allRows={allRows}
                        titleId={titleId}
                        isSubmitting={isSubmitting}
                        isOwnRequest={isOwnRequest}
                        onClose={onClose}
                        onConfirm={onConfirm}
                    />
                </Dialog.Panel>
            </div>
        </Dialog>
    );
}

export default VacationDpDecisionModal;
